// components/common/ProtectedRoute.js - Componente para rutas protegidas
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import Loading from './Loading';

const ProtectedRoute = ({ 
  children, 
  requiredRole = null, 
  requiredBusinessArea = null 
}) => {
  const { authenticated, loading, hasRole, hasBusinessAreaAccess } = useAuth();
  const location = useLocation();

  // Mostrar loading mientras se verifica la autenticación
  if (loading) {
    return <Loading />;
  }

  // Redirigir a login si no está autenticado
  if (!authenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Verificar rol requerido
  if (requiredRole) {
    // Si es un array de roles, verificar si tiene al menos uno
    const hasRequiredRole = Array.isArray(requiredRole) 
      ? requiredRole.some(role => hasRole(role))
      : hasRole(requiredRole);
      
    if (!hasRequiredRole) {
      return <Navigate to="/unauthorized" replace />;
    }
  }

  // Verificar acceso a área de negocio
  if (requiredBusinessArea && !hasBusinessAreaAccess(requiredBusinessArea)) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
};

export default ProtectedRoute; 